export const COUPON_LENGTH_LIMIT = 5;
